import React from 'react';
import { COURSES } from '../data/mock';
import { ArrowUpRight, Award } from 'lucide-react';
import Section, { Reveal } from './Section';

export default function Courses() {
  return (
    <Section
      id="courses"
      eyebrow="SAMZ Academy"
      title={(
        <>
          Six Courses.<br />One Badge. The Whole System.
        </>
      )}
      lead="Complete all six courses and pass the certification assessment to earn the SAMZONE Badge, the on-platform credential that unlocks premium marketplace access, priority gigs, and rally invitations."
    >
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {COURSES.map((c, i) => (
          <Reveal key={c.code} delay={i * 60}>
            <div className="card-border rounded-2xl p-7 h-full flex flex-col group">
              <div className="flex items-center justify-between mb-6">
                <div className="pin-num">Course {c.code}</div>
                <div className="text-[10px] tracking-[0.18em] uppercase text-white/35">{c.topic}</div>
              </div>
              <h3 className="font-display text-white text-[34px] leading-[1] tracking-[-0.03em] mb-4">
                {c.name}
              </h3>
              <p className="text-white/60 text-[13.5px] leading-[1.65] mb-7">{c.body}</p>
              <div className="mt-auto pt-4 border-t border-white/8 flex items-center justify-between">
                <span className="text-[#22A773] text-[12px] tracking-[0.14em] uppercase">Included</span>
                <span className="w-8 h-8 rounded-full border border-white/15 flex items-center justify-center group-hover:border-[#22A773] group-hover:bg-[#22A773]/10 transition-all">
                  <ArrowUpRight size={14} className="text-white group-hover:text-[#22A773] transition" />
                </span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Badge callout */}
      <Reveal>
        <div className="mt-10 card-border rounded-2xl p-8 lg:p-10 grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-2 flex lg:justify-center">
            <div className="w-24 h-24 rounded-full border-2 border-[#CFA153] flex items-center justify-center bg-[#CFA153]/8">
              <Award size={42} className="text-[#CFA153]" />
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="pin-num mb-3 !text-[#CFA153]"> The SAMZONE Badge</div>
            <h3 className="font-display text-white text-[28px] md:text-[34px] leading-[1.05] tracking-[-0.02em] mb-3">
              Complete six courses. Earn the badge. Get first access to gigs on the marketplace.
            </h3>
            <p className="text-white/60 text-[14px] leading-[1.7]">
              The SAMZONE Badge verifies you understand the ecosystem, have completed academy training, and are ready to operate as a professional. It lives on your SAMZ profile and unlocks top-tier benefits when the marketplace launches.
            </p>
          </div>
          <div className="lg:col-span-3 lg:text-right">
            <a href="#signup" className="btn-gold">Sign Up <ArrowUpRight size={16} /></a>
          </div>
        </div>
      </Reveal>
    </Section>
  );
}
